var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_c('v-alert',{staticClass:"mb-3",attrs:{"value":_vm.value,"type":"info"}},[_vm._v(_vm._s(_vm.$t('timesheetCreatedButNotSaved'))+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }